import { DateObjectKinds } from "../../../../../../../documaker/domain/format/objects";
import { IDateObject } from "../../../../../../domain/editableFormat/objects";
import { IDateObjectBean } from "../../../beans/objects";

export class DateObjectKindTranslator {
  from(bean: IDateObjectBean): DateObjectKinds {
    if (bean["@source-file"] !== undefined) { // 新規オブジェクトについては空文字列でも許容するので属性があるかで判定.
      return DateObjectKinds.UserDefined;
    } else if (bean["@name"] && (0 < bean["@name"].length)) {
      return DateObjectKinds.HisItem;
    } else {
      return DateObjectKinds.Normal;
    }
  }

  to(object: IDateObject) {
    return {
    };
  }
}
